import React from 'react';
import { ScannedProduct } from '../scannerTypes';
import styles from './ProductDetail.module.css';

interface ProductDetailProps {
  product: ScannedProduct;
}

export const ProductDetail: React.FC<ProductDetailProps> = ({ product }) => {
  return (
    <div className={styles.card}>
      <div className={styles.imagePlaceholder}>
        {product.imageUrl ? (
          <img src={product.imageUrl} alt="Product" className={styles.image} />
        ) : (
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M38 6H10C7.79 6 6 7.79 6 10V38C6 40.21 7.79 42 10 42H38C40.21 42 42 40.21 42 38V10C42 7.79 40.21 6 38 6ZM38 38H10V10H38V38ZM18 28L22 33.03L28 26L36 36H12L18 28Z" fill="#9CA3AF" />
          </svg>
        )}
      </div>
      <div className={styles.details}>
        <span className={styles.skuBadge}>{product.sku}</span>
        <div className={styles.infoGrid}>
          <div className={styles.infoField}>
            <span className={styles.label}>Location</span>
            <span className={styles.value}>{product.location}</span>
          </div>
          <div className={styles.infoField}>
            <span className={styles.label}>Available Qty</span>
            <span className={styles.value}>{product.availableQty}</span>
          </div>
          <div className={styles.infoField}>
            <span className={styles.label}>Batch</span>
            <span className={styles.value}>{product.batch}</span>
          </div>
          <div className={styles.infoField}>
            <span className={styles.label}>Expiry</span>
            <span className={styles.value}>{product.expiry}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
